/* Shim for the forked design editor: opens the Brightivity Credits modal. */
import { useEffect } from 'react';
import { useWallet } from '../../app/wallet.jsx';

export default function CreditPurchaseModal({ isOpen, onClose }) {
  const { openCredits } = useWallet();
  useEffect(() => { if (isOpen) { openCredits(); onClose && onClose(); } }, [isOpen]); // eslint-disable-line react-hooks/exhaustive-deps
  return null;
}
